import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { User } from "lucide-react";
import type { UserActivityRow } from "@/lib/dashboardCosts";

const formatNumber = (n: number) => new Intl.NumberFormat("es-ES").format(n);

const UserActivityTable = ({ rows, total }: { rows: UserActivityRow[]; total: number }) => (
  <Card>
    <CardContent className="p-0">
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Usuario</TableHead>
              <TableHead className="text-right">Documentos tramitados</TableHead>
              <TableHead className="text-right">%</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} className="p-8 text-center text-sm text-muted-foreground">
                  No hay documentos tramitados en este periodo.
                </TableCell>
              </TableRow>
            ) : (
              <>
                {rows.map((r) => (
                  <TableRow key={r.userId}>
                    <TableCell>
                      <span className="inline-flex items-center gap-2">
                        <User className="h-3 w-3 text-muted-foreground" />
                        <span>
                          {r.name}
                          {r.email !== "—" && (
                            <span className="ml-2 text-xs text-muted-foreground">{r.email}</span>
                          )}
                        </span>
                      </span>
                    </TableCell>
                    <TableCell className="text-right font-mono">{formatNumber(r.documents)}</TableCell>
                    <TableCell className="text-right font-mono text-muted-foreground">
                      {total > 0 ? ((r.documents / total) * 100).toFixed(1) : "0.0"}%
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow className="border-t-2 font-semibold">
                  <TableCell>Total</TableCell>
                  <TableCell className="text-right font-mono">{formatNumber(total)}</TableCell>
                  <TableCell className="text-right font-mono text-muted-foreground">100%</TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </div>
    </CardContent>
  </Card>
);

export default UserActivityTable;
